export function usePostFilterForm() {
  function PostsListForm(form) {
    if (!(form instanceof Element)) {
      return;
    }

    const fieldsets = form.querySelectorAll("fieldset");
    const inputs = Array.from(form.querySelectorAll("input"));
    const clearBtn = form.querySelector(".posts-filter__clear");

    fieldsets.forEach((fieldset) => {
      if (fieldset.dataset.type === "checkboxes") {
        const expandButton = fieldset.querySelector(
          ".posts-filter__legend-button"
        );
        const group = fieldset.querySelector(".posts-filter__group");
        const inputList = fieldset.querySelector(".posts-filter__input-list");

        group.style.setProperty("--groupHeight", `${inputList.offsetHeight}px`);

        expandButton.addEventListener("click", () => {
          const ariaExpanded = expandButton.getAttribute("aria-expanded");
          if (ariaExpanded === "true") {
            expandButton.setAttribute("aria-expanded", false);
            group.setAttribute("aria-expanded", false);
          } else {
            expandButton.setAttribute("aria-expanded", true);
            group.setAttribute("aria-expanded", true);
          }
        });
      }
    });

    function showClearBtn() {
      clearBtn.classList.add("active");
    }

    inputs.forEach((input) => {
      input.addEventListener("change", showClearBtn);
    });
  }

  const postFilterForm = document.querySelector(".posts-filter__form");

  postFilterForm && PostsListForm(postFilterForm);
}
